import React, { useState, useEffect } from 'react'
import OpenSeadragonViewerImpl from './OpenSeadragonViewerImpl'
import { getCachedTileSource } from '@/lib/dzi-cache'
import { getAuthHeaders } from '@/lib/auth-token'

type ThumbnailProps = Pick<React.HTMLAttributes<HTMLDivElement>, 'className' | 'style'> & {
  src: string
  width: number
  height: number
  initialBounds?: { x1: number; y1: number; x2: number; y2: number }
}

export function Thumbnail(props: ThumbnailProps) {
  const [isLoaded, setIsLoaded] = useState(false)
  const [tileSource, setTileSource] = useState<any>(null)

  useEffect(() => {
    let cancelled = false

    getCachedTileSource(props.src)
      .then((parsed) => {
        if (!cancelled) {
          setTileSource(parsed)
        }
      })
      .catch((error: unknown) => {
        console.error('Failed to load DZI:', error)
      })

    return () => {
      cancelled = true
    }
  }, [props.src])

  return (
    <div
      data-thumbnail-inner="true"
      style={{
        width: `${props.width}px`,
        height: `${props.height}px`,
        position: 'relative',
        borderRadius: '0.375rem',
        overflow: 'hidden',
        ...props.style,
      }}
    >
      {!isLoaded && (
        <div className="chrome-panel absolute inset-0 rounded-md border border-border-default/40" />
      )}

      {tileSource && (
        <OpenSeadragonViewerImpl
          initialBounds={props.initialBounds}
          options={{
            tileSources: tileSource,
            loadTilesWithAjax: true,
            ajaxHeaders: getAuthHeaders(),
            immediateRender: true,
            preload: false,
            blendTime: 0,
            alwaysBlend: false,
            drawer: ['canvas', 'html'],
            panHorizontal: false,
            panVertical: false,
            showFlipControl: false,
            showHomeControl: false,
            showFullPageControl: false,
            showNavigationControl: false,
            showNavigator: false,
            showReferenceStrip: false,
            showRotationControl: false,
            showSequenceControl: false,
            showZoomControl: false,
            zoomPerScroll: 1,
            zoomPerClick: 1,
            gestureSettingsMouse: {
              clickToZoom: false,
              dblClickToZoom: false,
              dragToPan: false,
              flickEnabled: false,
              pinchToZoom: false,
              scrollToZoom: false,
            },
            gestureSettingsTouch: {
              clickToZoom: false,
              dblClickToZoom: false,
              dragToPan: false,
              flickEnabled: false,
              pinchToZoom: false,
              scrollToZoom: false,
            },
            gestureSettingsPen: {
              clickToZoom: false,
              dblClickToZoom: false,
              dragToPan: false,
              flickEnabled: false,
              pinchToZoom: false,
              scrollToZoom: false,
            },
            gestureSettingsUnknown: {
              clickToZoom: false,
              dblClickToZoom: false,
              dragToPan: false,
              flickEnabled: false,
              pinchToZoom: false,
              scrollToZoom: false,
            },
          } as any}
          className="noninteractive"
          style={{
            width: `${props.width}px`,
            height: `${props.height}px`,
            opacity: isLoaded ? 1 : 0,
            transition: 'opacity 0.3s ease-in-out',
          }}
          onLoad={() => { setIsLoaded(true) }}
        />
      )}
    </div>
  )
}

export default Thumbnail
